module.exports = __webpack_public_path__ + "img/menu12.7c6eea5a.png";